import React from 'react';

import '@app/scss/pages/contactUs.scss';

import NewConcatForm from '@app/components/UI/ContactForm/NewContactForm';

const ContactUs: React.FC = () => {
	return (
		<div className="contact-us">
			<div className="contact-us__section">
				<div className="perspective">
					<h1 className="contact-us__title hero-text hero">
						<span className="clipped">Demo Now</span>!
					</h1>
				</div>
			</div>
			<NewConcatForm/>
		</div>
	);
};

export default ContactUs;